import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const grcApi = createApi({
    reducerPath: 'grcApi',
    keepUnusedDataFor: 0,
    baseQuery: fetchBaseQuery({
        baseUrl: '/Grc',
        prepareHeaders: prepareAuthHeaders,
    }),
    endpoints: (builder) => ({
        getStudentRating: builder.query({
            query: ({studentId, semesterId}) => ({
                url: `/GetStudentRating`,
                method: 'GET',
                params: {studentId, semesterId}
            }),
        }),
        getStudentsExtraGrcPointsOfCourse: builder.query({
            query: ({courseId, flowNumber, semesterId}) => ({
                url: `/GetStudentsExtraGrcPointsOfCourse`,
                method: 'GET',
                params: {courseId, flowNumber, semesterId}
            }),
        }),
        updateStudentsExtraGrcPointsOfCourse: builder.mutation({
            query: ({ data }) => ({
                url: `/UpdateStudentsExtraGrcPointsOfCourse`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Post'],
        }),
        removeTechMap: builder.mutation({
            query: ({ data }) => ({
                url: `/RemoveTechMap`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Post'],
        }),
        saveTechMap: builder.mutation({
            query: ({ data }) => ({
                url: `/SaveTechMap`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Post'],
        }),
        getTechMap: builder.query({
            query: ({courseId, disciplineId, virtualGroupId}) => ({
                url: `/GetTechMap`,
                method: 'GET',
                params: {courseId, disciplineId, virtualGroupId}
            })
        }),
        getTechMapByStatementId: builder.query({
            query: ({statementId}) => ({
                url: `/GetTechMapByStatementId`,
                method: 'GET',
                params: {statementId}
            })
        }),
        getGrsParams: builder.query({
            query: () => ({
                url: `/GetGrsParams`,
                method: 'GET'
            })
        }),
    }),
});

export const { 
    useGetStudentRatingQuery, 
    useGetStudentsExtraGrcPointsOfCourseQuery,
    useUpdateStudentsExtraGrcPointsOfCourseMutation,
    useRemoveTechMapMutation,
    useSaveTechMapMutation,
    useGetTechMapQuery,
    useGetTechMapByStatementIdQuery,
    useGetGrsParamsQuery
} = grcApi;
